import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import { Applies } from './pages/Applies';
import { Archives } from './pages/Archives';
import { EventDetail } from './pages/EventDetail';
import { EventRegistrations } from './pages/EventRegistrations';
import { Events } from './pages/Events';
import { Home } from './pages/Home';
import { Interesteds } from './pages/Interesteds';
import { LinkOpens } from './pages/LinkOpens';
import { Login } from './pages/Login';
import { Messages } from './pages/Messages';
import { MobileAppPage } from './pages/MobileAppPage';
import { NewRegistrations } from './pages/NewRegistration';
import { NotResponds } from './pages/NotResponds';
import { OnSite } from './pages/OnSite';
import { ModeratorView } from './pages/ModeratorView';
import { SeatOrder } from './pages/SeatOrder/SeatOrder';
import { SendNotification } from './pages/SendNotification';
import { Surveys } from './pages/Surveys';
import { Waitings } from './pages/Waitings';

const router = createBrowserRouter([
  { path: '/', element: <Login />},
  // { path: '/events', element: <Events />},
  { path: '/home', element: <Home />, children: [
    {path: 'events', element: <Events />},
    {path: 'surveys', element: <Surveys />},
    {path: 'archives', element: <Archives />},
    {path: 'detail', element: <EventDetail />},
    {path: 'registrations', element: <EventRegistrations />},
    {path: 'onsite', element: <OnSite />},
    {path: 'interesteds', element: <Interesteds />},
    {path: 'waiting', element: <Waitings />},
    {path: 'applies', element: <Applies />},
    {path: 'notresponded', element: <NotResponds />},
    {path: 'newregistration', element: <NewRegistrations />},
    {path: 'seatorders', element: <SeatOrder />},
    {path: 'moderatorview', element: <ModeratorView />},
    {path: 'sendnotification', element: <SendNotification />},
    {path: 'link-opens', element: <LinkOpens />},
    {path: 'messages', element: <Messages />},
  ]},
  { path: '/app', element: <MobileAppPage /> },
])

function App() {
  return <RouterProvider router={router} />
}

export default App;
